/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

/*
 * If the token swap failed in Authorize lambda then we logout before continuing PKCE
 */

import { Auth } from "aws-amplify";

import { QUERY_PARAMS_KEYS, STORAGE_KEYS } from "../const";
import { eraseAllCookies } from "./cookieHelper";

const checkForceAuth = async () => {
	const forceAuth =
		new URLSearchParams(window.location.search).get(
			QUERY_PARAMS_KEYS.forceAuth
		) || false;

	if (forceAuth) {
		eraseAllCookies();

		localStorage.removeItem(STORAGE_KEYS.clientID);

		await Auth.signOut();
	}
};

export default checkForceAuth;
